<div class="text-disc-renderer">
    <p class="link-icon">
        <span>
            <span class="link" [class]="classValue">{{ text }}</span>
            @if(isMandatory){<span class="mendetory">*</span>}
        </span>
        @if(isIcon){<img [src]="ICONS.CHEVRON_RIGHT"/>}
    </p>
    @if(description){<p>{{ description }}</p>}
</div>